require("./plugins/bootstrap.js");
require("./plugins/magnific-popup.js");
require("./plugins/slick.js");
require("./plugins/bootstrap-datepicker.js");
require("./plugins/jquery.mmenu.min.all.js");

require("./modules/forms.js");
require("./modules/reviews.js");
require("./modules/fastbooker.js");
require("./modules/mobile-nav.js");
require("./modules/sliders.js");
require("./modules/gallery.js");
// require("./modules/nav.js");

if ($('#maps').length){
require("./modules/location.js");
}
